@if (showAnnouncement && announcementContent) {
	<div
		class="announcement-data"
		[ngClass]="isHomePage ? 'home-page-banner' : 'notification-slider'"
		tabindex="0"
	>
		@if (announcementContent?.text) {
			<div
				class="notification-container"
				[ngClass]="{ secondary: announcementRead && !isAdminNotification }"
			>
				<div class="row">
					<div class="col-md-auto icon-padding">
						<i class="fa fa-bullhorn"></i>
					</div>
					<div class="col content-title">
						<div
							class="row"
							[ngClass]="isHomePage ? 'd-flex align-items-end' : ''"
						>
							<div 
								class="col banner-title">
								Announcement
							</div>
							<div
								class="col justify-content-end d-flex notification-date aut-date-stamp"
							>
								<span
									class="aut-date"
									[ngClass]="{ 'notification-padding': announcementRead }"
									>{{ announcementContent.startDate | date }}</span
								>
								@if (!announcementRead && !isAdminNotification && !isHomePage) {
									<i
										class="fa fa-circle"
										(click)="onMarkAsRead(announcementContent.id)"
									></i>
								}
							</div>
						</div>
						<div class="row">
							@if (announcementContent.title) {
								<div class="col banner-msg-title">
									<span 
										[innerHTML]="announcementContent.title">
									</span>
								</div>
							}
							<div
								class="col justify-content-end d-flex notification-date aut-date-stamp"
							>
								<span [ngClass]="{ 'notification-padding': !isHomePage }"
									>{{ announcementContent.startDate | date: 'hh:mm a' }}
									{{ announcementTimeZone }}</span
								>
							</div>
						</div>
						<div class="row">
							<div
								class="col content-text-wrap content-text notification-padding"
							>
								<ea-read-more-or-less
									[text]="announcementContent.text"
									[moreText]="constants.TUITION.MORE_TEXT"
									[lessText]="constants.TUITION.LESS_TEXT"
									(onClick)="onMarkAsRead(announcementContent.id)"
									[maxLength]="maxBannerTextLength"
									[ngClass]="{
										'text-align':
											announcementContent.text?.length < maxBannerTextLength
									}"
								>
								</ea-read-more-or-less>
							</div>
						</div>
					</div>
					@if (isHomePage) {
						<div class="col-1 close d-flex justify-content-end">
							<button (click)="closeAnnouncementBanner()" name="close">
								<i class="fa fa-close fa-2x"></i>
							</button>
						</div>
					}
				</div>
			</div>
		}
	</div>
}
